import * as authBackground from './auth_background.png'
import * as chatBackground from './chat-bg.png'
import * as mainLogo from './opp_main_logo.png'
import * as passwordIcon from './icons/password_icon.svg'
import * as userIcon from './icons/user_icon.svg'
import * as sampleAvatar from './sample_avatar.jpg'
import * as emailIcon from './icons/email_icon.svg'
import * as openInNewWindowIcon from './icons/open_in_new_window.svg'
import * as returnIcon from './icons/return_icon.svg'

const images = {
  authBackground,
  mainLogo,
  passwordIcon,
  sampleAvatar,
  userIcon,
  emailIcon,
  chatBackground,
  openInNewWindowIcon,
  returnIcon,
}

export default images



// WEBPACK FOOTER //
// ./src/Assets/Images/index.js